import script from "./SegmentedButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./SegmentedButtons.vue?vue&type=script&lang=ts&setup=true"

import "./SegmentedButtons.vue?vue&type=style&index=0&id=75611ca4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75611ca4"]])

export default __exports__